import type { ChangeEvent } from 'react'
import { AuthLayout } from '@/modules/auth/ui/components'
import { formatTryAgainLabel } from '@/shared/ui/hooks'
import { Button, Input } from '@/shared/ui/primitives'

export type AccountForkStateProps = {
  inviteEmail: string
  organizationName: string
  yesEmail: string
  isSubmitting: boolean
  cooldownSeconds: number
  onYesEmailChange: (value: string) => void
  onChooseNo: () => void
  onChooseYes: () => void
}

export function AccountForkState({
  inviteEmail,
  organizationName,
  yesEmail,
  isSubmitting,
  cooldownSeconds,
  onYesEmailChange,
  onChooseNo,
  onChooseYes,
}: AccountForkStateProps) {
  const subtitle = inviteEmail
    ? `${organizationName} invited ${inviteEmail}. Do you already have a BlindBook account?`
    : `${organizationName} invited you. Do you already have a BlindBook account?`

  return (
    <AuthLayout title="Do you have a BlindBook account?" subtitle={subtitle}>
      <div className="flex flex-col gap-4">
        <Button type="button" variant="default" onClick={onChooseNo} disabled={isSubmitting}>
          No, create my account
        </Button>

        <div className="flex flex-col gap-2 rounded-lg border p-4">
          <label htmlFor="account-fork-email" className="text-sm text-fg-dim">
            Yes — sign in with the email on my existing account
          </label>
          <Input
            id="account-fork-email"
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={yesEmail}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onYesEmailChange(e.target.value)}
            disabled={isSubmitting}
          />
          <Button
            type="button"
            variant="outline"
            onClick={onChooseYes}
            disabled={isSubmitting || cooldownSeconds > 0 || yesEmail.trim().length === 0}
          >
            {cooldownSeconds > 0 ? formatTryAgainLabel(cooldownSeconds) : 'Send me a sign-in code'}
          </Button>
        </div>
      </div>
    </AuthLayout>
  )
}
